
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { HealthData } from "zaehlerfreunde-proto-types/device_pb";

@Component
export default class DeviceHealth extends Vue {
  @Prop() healthInfo: HealthData[] | null;
}
